// extracted by mini-css-extract-plugin
export default {"root":"OrderDetail_root__9Shvz","body":"OrderDetail_body__MA1us"};